// use-team-members.ts — Teams suite, query (derived)
//
// Returns just the members of a team. Today this is a selector on `useTeam(teamId)` —
// the team-detail endpoint already includes members, so a separate network call would
// be wasteful. If a dedicated `/teams/{id}/members` endpoint is added later, switch
// this to a real query without changing the public surface.

'use client';

import type { SavedTeamMember } from '@cabal/shared/domain/session/team/member/types.js';
import type { QueryOptions, QueryResult } from '@/types/async-protocol';
import { useTeam } from './use-team';

export function useTeamMembers(
  teamId: string | null,
  options?: QueryOptions,
): QueryResult<SavedTeamMember[]> {
  const team = useTeam(teamId, options);
  return {
    data: team.data?.members ?? null,
    status: team.status,
    error: team.error,
    refetch: team.refetch,
  };
}
